export const queryKeys = {
  CONTRACT_QR: 'CONTRACT_QR'
};
